import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { fieldsMustMatchValidator } from '../../_shared/validators/fields-must-match.validator';
import { passwordValidator } from '../../_shared/validators/password-validator';

import { SharedModule } from '../../_shared/shared.module';
import { SessionService } from '../../_shared/services/session.service';
import { FlashService } from '../../_shared/services/flash.service';
// import { UtilService } from '../../_shared/services/util.service';

import { UserService } from '../../users/shared/user.service';

@Component({
  selector: 'app-password-recovery-edit-page',
  templateUrl: './password-recovery-edit-page.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class PasswordRecoveryEditPageComponent implements OnInit {
  form: FormGroup;

  formSubmited = false;

  // formSuccessMsg = '';
  formErrorMsg = '';

  // serverErrors = [];
  sendingForm = false;

  // When we want custom messages
  errorMessages = {
    password: {
      // required: 'REQUIRED_PASSWORD',
      minlength: 'INVALID_LENGTH_PASSWORD',
      invalid: 'INVALID_FORMAT_PASSWORD',
    },
    passwordConfirmation: {
      fieldsMustMatch: 'INVALID_MATCH_PASSWORDS',
    },
  };

  validToken = false;

  // private token = this.activatedRoute.snapshot.params['token'];
  // Angular+
  // private token = this.activatedRoute.snapshot.queryParams['tk'];
  // private email = this.activatedRoute.snapshot.queryParams['email'];

  // AngularJS
  private token = '';
  private email = '';

  // route

  // UserService
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private flashService: FlashService,
    private sessionService: SessionService,
    private userService: UserService,
    @Inject('$routeParams') private routeParamsJs: any
  ) {
    // User is logged
    if (this.sessionService.isLoggedIn()) {
      this.router.navigate(['ng']); // reload ??

      return;
    }

    // // hack - refactor - avoid setTimeout
    // setTimeout(() => {
    //   const images = ['tim-bg-01.png', 'tim-bg-02.png', 'tim-bg-03.png'];
    //   document.getElementById('bgimg').style.backgroundImage =
    //     'url("../assets/img/' + images[Math.floor(Math.random() * images.length)] + '")';
    // }, 100);
  }

  ngOnInit() {
    // AngularJS
    this.token = this.routeParamsJs.tk;
    this.email = this.routeParamsJs.email;

    this.checkPasswordRecovery();
  }

  savePasswordRecovery() {
    this.formSubmited = true;

    if (this.form.invalid) return;

    this.sendingForm = true;

    this.userService.savePasswordRecovery(this.form.value, this.token, this.email).subscribe({
      next: () => {
        this.form.reset();

        this.flashService.setMessage('PASSWORD_RESET_MSG');
        this.router.navigate(['/ng/login']);
      },
      error: (response) => {
        this.formErrorMsg = response.error.error;

        this.sendingForm = true;
      },
    });
  }

  private checkPasswordRecovery() {
    this.userService.checkPasswordRecovery(this.token, this.email).subscribe({
      next: () => {
        this.validToken = true;

        // hack - refactor - avoid setTimeout
        setTimeout(() => {
          const images = ['tim-bg-01.png', 'tim-bg-02.png', 'tim-bg-03.png'];
          document.getElementById('bgimg').style.backgroundImage =
            'url("../assets/img/' + images[Math.floor(Math.random() * images.length)] + '")';
        }, 100);
        // console.log('next');
      },
      error: (response) => {
        this.flashService.setMessage(response.error.error);
        this.router.navigate(['/ng/login']); // ? keep ? to delete url params
      },
    });

    this.setPasswordRecoveryEditForm();
  }

  private setPasswordRecoveryEditForm() {
    this.form = this.formBuilder.group(
      {
        password: [
          '',
          {
            validators: [
              Validators.required,
              Validators.minLength(6),
              passwordValidator,

              // Validators.pattern(this.utilService.selectInputPattern('password')),
              // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
            ],
            updateOn: 'blur',
          },
        ],
        passwordConfirmation: [
          '',
          {
            validators: [
              Validators.required,
              Validators.minLength(6),
              fieldsMustMatchValidator('password'),
            ],
            updateOn: 'blur',
          },
        ],
      }
      // {
      //   validator: fieldsMustMatchValidator('password', 'passwordConfirmation'),
      // }
      // { updateOn: 'blur' }
    );
  }
}

// private utilService: UtilService,

// this.route.queryParams.subscribe((params: Params) => {
// this.route.params.subscribe((params: Params) => {
//   this.checkPasswordRecovery(params['token'], params['email']);
// });
